import { FC, useState } from 'react';
import { Grid, TextField, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SCUIButton } from '../../../../atomic/atoms';
import { SCUIGeneralDrawerHeader } from '../../../../atomic/molecules';
import CargoManagementCommand from '../../../../services/command/cargoManagement/CargoManagementCommand.services';
import Swal from 'sweetalert2';
interface IProps {
    selectedRow?: any;
    setSelectedRow?: any;
    onClose?: any;
    refresh?: any;
}
export const SCUICargoOrderLimitEdit: FC<IProps> = ({ selectedRow, setSelectedRow, onClose, refresh }) => {
    const { t } = useTranslation();
    const [orderLimit, setOrderLimit] = useState(0);

    const UpdateCargoOrderLimit = async () => {
        if (orderLimit < 0) {
            Swal.fire(t('general.error'), t('cargoManagement.orderLimitCanNotBeNegative'), 'error');
            return;
        }
        let paramsList = {
            updateCargoCompanyRequests: selectedRow.map((row: any) => {
                return {
                    shippingCompanyId: row.shippingCompanyId,
                    addressEntityId: row.countyId !== null ? row.countyId : row.cityId,
                    orderLimit: orderLimit,
                    validStartDate: new Date(),
                    validEndDate: new Date(),
                };
            }),
        };

        CargoManagementCommand.UpdateCargoLimit(paramsList)
            .then(() => {
                Swal.fire(t('general.updated'), ' ', 'success');
                refresh();
                onClose();
                setSelectedRow([]);
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            })
            .finally(() => {});
    };
    return (
        <form
            onSubmit={(e: any) => {
                e.preventDefault();
            }}
        >
            <div className="commentFilterContainer">
                {selectedRow && selectedRow.length > 0 && (
                    <Grid container spacing={1}>
                        <SCUIGeneralDrawerHeader header={t('cargoManagement.orderLimitUpdate')} onClose={onClose} />
                        <Grid
                            size={{
                                xs: 12,
                                md: 12,
                                lg: 12,
                                xl: 12
                            }}>
                            <Grid
                                style={{ marginTop: '1rem' }}
                                size={{
                                    xs: 12,
                                    md: 12,
                                    lg: 12,
                                    xl: 12
                                }}>
                                <Tooltip
                                    title={
                                        selectedRow &&
                                        selectedRow.map((item: any) => item.shippingCompanyName).join(', ')
                                    }
                                    placement="top"
                                >
                                    <TextField
                                        label={t('cargoManagement.shippingCompanyName')}
                                        defaultValue={
                                            selectedRow &&
                                            selectedRow.map((item: any) => item.shippingCompanyName).join(', ')
                                        }
                                        variant="outlined"
                                        type="text"
                                        id="shippingCompanyName"
                                        fullWidth
                                        disabled
                                    />
                                </Tooltip>
                            </Grid>
                            <Grid
                                style={{ marginTop: '2rem' }}
                                size={{
                                    xs: 12,
                                    md: 12,
                                    lg: 12,
                                    xl: 12
                                }}>
                                <Tooltip
                                    title={selectedRow && selectedRow.map((item: any) => item.countyName).join(', ')}
                                    placement="top"
                                >
                                    <TextField
                                        label={t('cargoManagement.countyName')}
                                        id="countyName"
                                        defaultValue={
                                            selectedRow && selectedRow.map((item: any) => item.countyName).join(', ')
                                        }
                                        type="text"
                                        variant="outlined"
                                        fullWidth
                                        disabled
                                    />
                                </Tooltip>
                            </Grid>
                            <Grid
                                style={{ marginTop: '2rem' }}
                                size={{
                                    xs: 12,
                                    md: 12,
                                    lg: 12,
                                    xl: 12
                                }}>
                                <TextField
                                    id="orderLimitValue"
                                    defaultValue={selectedRow && selectedRow.orderLimit}
                                    type="text"
                                    label={t('cargoManagement.orderLimit')}
                                    fullWidth
                                    onChange={(event) => {
                                        setOrderLimit(Number(event.target.value));
                                    }}
                                />
                            </Grid>
                        </Grid>
                        <Grid
                            container
                            spacing={1}
                            sx={{ minHeight: { xs: 250, lg: 450 }, paddingBottom: '1rem' }}
                        ></Grid>
                        <Grid
                            style={{
                                position: 'absolute',
                                bottom: 0,
                                width: 380,
                                marginBottom: '20px',
                            }}>
                            <SCUIButton
                                text={t('general.update')}
                                type="primary"
                                sizeType="default"
                                buttonType="submit"
                                size={'s'}
                                fullwidth
                                onClick={UpdateCargoOrderLimit}
                            />
                        </Grid>
                    </Grid>
                )}
            </div>
        </form>
    );
};
